import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import GolfClubTeeTimeBookingOutcomeMix from "../../../assets/components/reports/GolfClubTeeTimeBookingOutcomeMix";

class GolfClubTeeTimeBookingOutcomeMixReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Golf Club Tee-Time Booking Outcome Mix</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <GolfClubTeeTimeBookingOutcomeMix />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default GolfClubTeeTimeBookingOutcomeMixReport;
